import { useTranslation } from "react-i18next";
import { Scale } from "lucide-react";
import { SiDiscord, SiTencentqq } from "react-icons/si";

const appVersion = process.env.NEXT_PUBLIC_APP_VERSION ?? "0.1.0";

export default function AppFooter() {
  const { t } = useTranslation("app");

  return (
    <footer className="border-t mt-auto">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-4 px-2 text-sm text-muted-foreground">
        <div className="flex items-center gap-2 text-xs sm:text-sm">
          <span>{t("footer.feedback")}</span>
          <a
            href="https://qm.qq.com/q/OFNdDzjk4Y"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 hover:text-foreground transition-colors"
          >
            <SiTencentqq className="h-3.5 w-3.5" />
            <span>1075221296</span>
          </a>
          <span className="text-muted-foreground/60">|</span>
          <a
            href="https://discord.gg/6V7CupPwb6"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 hover:text-foreground transition-colors"
          >
            <SiDiscord className="h-3.5 w-3.5" />
            <span>Discord</span>
          </a>
        </div>
        <div className="flex items-center gap-2 sm:gap-3 text-xs sm:text-sm">
          <span className="flex items-center gap-1">
            <Scale className="h-3 w-3" />
            MIT License
          </span>
          <span className="text-muted-foreground/60">|</span>
          <span>{t("footer.unofficial")}</span>
          <span className="text-muted-foreground/60">|</span>
          <span className="font-mono">{appVersion}</span>
        </div>
      </div>
    </footer>
  );
}
